// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Billing = function Billing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.778 3.889c.305 0 .555.25.555.555v1.112H1.667V4.444c0-.305.25-.555.555-.555zm.555 3.611v8.056c0 .305-.25.555-.555.555H2.222a.557.557 0 0 1-.555-.556V7.5h16.666M2.223 2.222A2.224 2.224 0 0 0 0 4.444v11.112c0 1.225.997 2.222 2.222 2.222h15.556A2.224 2.224 0 0 0 20 15.556V4.444a2.224 2.224 0 0 0-2.222-2.222zm1.944 10.556a.83.83 0 0 0-.834.833c0 .462.372.833.834.833h1.666a.83.83 0 0 0 .834-.833.83.83 0 0 0-.834-.833z"
  }));
};
